
const Twitter = () => {
  return (
    <div>Twitter</div>
  )
}

export default Twitter